import { render, staticRenderFns } from "./PasswordForm.vue?vue&type=template&id=649be056&scoped=true"
import script from "./PasswordForm.vue?vue&type=script&lang=js"
export * from "./PasswordForm.vue?vue&type=script&lang=js"
import style0 from "./PasswordForm.vue?vue&type=style&index=0&id=649be056&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649be056",
  null
  
)

export default component.exports